var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M324.584,189.548c-13.778-23.587-39.296-39.479-68.584-39.479s-54.806,15.892-68.584,39.479H324.584 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M260.561,112.552c0,3.961-4.561,28.69-4.561,28.69s-4.561-24.728-4.561-28.69 c0-3.961,2.042-7.172,4.561-7.172C258.519,105.38,260.561,108.59,260.561,112.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M341.737,149.954c-2.801,2.801-23.511,17.062-23.511,17.062s14.261-20.711,17.062-23.511 c2.801-2.801,6.516-3.628,8.297-1.846C345.365,143.438,344.538,147.154,341.737,149.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M176.713,143.505c2.801,2.801,17.062,23.511,17.062,23.511s-20.711-14.261-23.511-17.062 c-2.801-2.801-3.628-6.516-1.846-8.297C170.197,139.876,173.912,140.703,176.713,143.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M215.559,119.689c1.516,3.66,6.765,28.252,6.765,28.252s-13.677-21.101-15.192-24.76 c-1.515-3.659-0.858-7.407,1.469-8.372C210.927,113.844,214.042,116.029,215.559,119.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M304.868,123.18c-1.516,3.66-15.192,24.76-15.192,24.76s5.249-24.591,6.765-28.252 c1.516-3.66,4.631-5.845,6.958-4.881S306.385,119.52,304.868,123.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M237.274,113.974c0.788,3.882,1.233,29.024,1.233,29.024s-9.385-23.328-10.173-27.211 c-0.788-3.882,0.576-7.435,3.044-7.936C233.848,107.35,236.488,110.091,237.274,113.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M324.266,134.494c-2.188,3.302-19.651,21.395-19.651,21.395s9.859-23.132,12.047-26.434 s5.664-4.851,7.764-3.459S326.454,131.192,324.266,134.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M161.252,160.975c3.302,2.188,21.395,19.651,21.395,19.651s-23.132-9.859-26.434-12.047 s-4.851-5.664-3.459-7.764C154.146,158.716,157.951,158.787,161.252,160.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M194.589,129.913c2.214,3.285,12.246,26.343,12.246,26.343s-17.598-17.961-19.811-21.246 c-2.214-3.285-2.314-7.09-0.224-8.497C188.888,125.106,192.376,126.628,194.589,129.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M355.328,167.83c-3.285,2.214-26.343,12.246-26.343,12.246s17.961-17.598,21.246-19.811 c3.285-2.214,7.09-2.314,8.497-0.224C360.136,162.13,358.613,165.618,355.328,167.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M282.812,115.582c-0.758,3.887-9.967,27.286-9.967,27.286s0.256-25.144,1.015-29.032 c0.759-3.887,3.377-6.649,5.849-6.167C282.182,108.151,283.57,111.694,282.812,115.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M285.529,116.258c-1.151,3.79-3.969,28.778-3.969,28.778s11.546-22.337,12.697-26.129 c1.151-3.79,0.129-7.456-2.281-8.188C289.567,109.987,286.68,112.468,285.529,116.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M196.989,128.47c1.867,3.494,17.543,23.155,17.543,23.155s-7.63-23.96-9.497-27.454 c-1.867-3.494-5.181-5.364-7.403-4.177C195.409,121.182,195.122,124.975,196.989,128.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M356.771,170.23c-3.493,1.867-23.155,17.543-23.155,17.543s23.96-7.63,27.454-9.497 c3.493-1.867,5.364-5.181,4.177-7.403C364.061,168.651,360.266,168.364,356.771,170.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M326.518,136.159c-2.514,3.062-14.679,25.068-14.679,25.068s19.217-16.218,21.73-19.281 c2.514-3.062,2.973-6.839,1.026-8.438C332.648,131.911,329.032,133.097,326.518,136.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M162.918,158.723c3.062,2.514,25.068,14.679,25.068,14.679s-16.218-19.217-19.281-21.73 s-6.839-2.973-8.438-1.026C158.669,152.594,159.855,156.21,162.918,158.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M240.044,113.558c0.387,3.943,7.346,28.106,7.346,28.106s2.12-25.056,1.732-28.999 c-0.387-3.943-2.734-6.938-5.24-6.691C241.375,106.22,239.657,109.615,240.044,113.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M263.061,112.676c-0.394,3.942,1.686,29.001,1.686,29.001s6.996-24.152,7.39-28.094 s-1.319-7.34-3.826-7.591C265.805,105.742,263.455,108.735,263.061,112.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M178.569,141.825c2.509,3.065,21.699,19.314,21.699,19.314s-12.131-22.026-14.639-25.091 c-2.509-3.065-6.123-4.257-8.072-2.663C175.607,134.98,176.06,138.759,178.569,141.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M343.416,151.81c-3.065,2.509-19.314,21.699-19.314,21.699s22.026-12.131,25.091-14.639 s4.257-6.123,2.663-8.072C350.261,148.849,346.483,149.301,343.416,151.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M307.13,124.252c-1.873,3.491-9.54,27.438-9.54,27.438s15.706-19.637,17.579-23.127 c1.873-3.491,1.59-7.286-0.629-8.477C312.32,118.895,309.003,120.76,307.13,124.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M151.01,178.111c3.491,1.873,27.438,9.54,27.438,9.54s-19.637-15.706-23.127-17.579 c-3.491-1.873-7.286-1.59-8.477,0.63C145.654,172.921,147.519,176.238,151.01,178.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M217.916,118.847c1.144,3.793,12.657,26.148,12.657,26.148s-2.778-24.992-3.924-28.783 c-1.144-3.793-4.028-6.276-6.439-5.548C217.799,111.391,216.771,115.055,217.916,118.847z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/mw.26d9a0b6f32008d571fdc2d3ec880523.svg";
export { ForwardRef as ReactComponent };